type ValidHeightKey = 'height-160' | 'height-150' | 'height-120' | 'height-80' | 'height-50'

export const heightMapping = {
  'height-160': 'h-[120px] lg:h-[160px]',
  'height-150': 'h-[120px] lg:h-[150px]',
  'height-120': 'h-[60px] lg:h-[120px]',
  'height-80': 'h-[60px] lg:h-[80px]',
  'height-50': 'h-[50px] lg:h-[50px]',
} as const

export type HeightMapping = typeof heightMapping
export type ValidHeightType = HeightMapping[ValidHeightKey]

export const getHeightValue = (height: ValidHeightKey | null | undefined): ValidHeightType | '' => {
  return heightMapping[height ?? 'height-120']
}
